import { render, staticRenderFns } from "./new-mailbox-button.vue?vue&type=template&id=08d5fa72&"
import script from "./new-mailbox-button.vue?vue&type=script&lang=ts&"
export * from "./new-mailbox-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports